import React, { memo, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { ApplicationState } from "../../../store";
import { TimelineState } from "../../../store/timeline/types";
import { contains, updatePaneTime, doBrowseGoTo, skipGapsStipTime } from "../../../utils";
import { APIState } from "../../../store/API/types";
import { BookmarkState } from "../../../store/bookmarks/types";
import { RouterState } from "connected-react-router";
import { BrowseState } from "../../../store/browse/types";
import { SettingsState } from "../../../store/settings/types";
import { Routes } from '../../../types';
import { resetTimestrips, setTimelineDate } from '../../../store/timeline/actions';
import { LayoutState } from '../../../store/layouts/types';
import service from '../../../services';

interface Props {
  time: number,
  dir: number
}

const BrowsePaneUpdater: React.FC<Props> = ({time, dir}) => {
  const {token} = useSelector<ApplicationState, APIState>(state => state.API);
  const {browsePanes} = useSelector<ApplicationState, BrowseState>(state => state.browse);
  const {bookmarks} = useSelector<ApplicationState, BookmarkState>(state => state.bookmarks);
  const {location} = useSelector<ApplicationState, RouterState>(state => state.router);
  const {isLocalTime} = useSelector<ApplicationState, SettingsState>(state => state.settings);
  const {playbackMode} = useSelector<ApplicationState, TimelineState>(state => state.timeline);
  const {checkedPane} = useSelector<ApplicationState, LayoutState>(state => state.layouts);

  const dispatch = useDispatch();

  const isAlerts = location.pathname === Routes.alerts;
  const isBookmarks = location.pathname === Routes.bookmarks;

  const panes = isBookmarks ? bookmarks : browsePanes;

  const updateThumbnails = (time: number) => {
    Object.entries(panes)
      .filter(([pane]: any) => pane < 2)
      .map(([pane, {timestrips, success, timeStripFetch, id}]: any, i: number) => {
        updatePaneTime(pane, time, isLocalTime);
        if (timestrips && success && !timeStripFetch && token) {
          if (checkedPane == pane) {
            if (contains(timestrips, time)) {
              doBrowseGoTo(token, time, pane, dir, id, service);
            } else {
              if (playbackMode === 'play' || playbackMode === 'back') {
                if (!timestrips) return null;

                const gotoTime = skipGapsStipTime(timestrips, time, dir, pane);

                if (gotoTime == null) return null;
                dispatch(setTimelineDate(gotoTime, dir === 1 ? 'play' : 'back'));
                dispatch(resetTimestrips(gotoTime));

                doBrowseGoTo(token, gotoTime, pane, dir, id, service);
              } else {
                doBrowseGoTo(token, time, pane, dir, id, service);
              }
            }
          } else {
            doBrowseGoTo(token, time, pane, dir, id, service);
          }
        } else if (isAlerts && success && token) {
          doBrowseGoTo(token, time, 0, dir, id, service);
        } else {
          // errorPaneTime(pane);
        }
        return null;
      });
  };

  useEffect(() => {
    updateThumbnails(Math.round(time));
  }, [time]);

  return null
};

export default memo(BrowsePaneUpdater)